import { gql } from '@apollo/client'

export default gql(`
    mutation($contents: [UpdateContentItemInput] $project: String) {
        batchUpdateContentItem(input: $contents project: $project ) {
            id
        }
    }`
)
